import type { DateString, IanaTimezone } from '#/types/TypedDateString';
import {
  datetimeFromParts,
  offsetDateInstance,
} from '#/utils/string/datetime/convertDatetimeString';

export function serializeActionDate({
  timezone,
  endsGT,
  startsLT,
}: {
  timezone: IanaTimezone;
  endsGT: DateString | null;
  startsLT: DateString | null;
}) {
  const serialized: { startsLT?: number; endsGT?: number } = {};

  if (endsGT) {
    serialized.endsGT = Math.floor(
      datetimeFromParts({
        date: endsGT,
        time: '00:00:00',
        timezone,
      }).getTime() / 1000,
    );
  }

  if (startsLT) {
    serialized.startsLT = Math.floor(
      datetimeFromParts({
        date: startsLT,
        time: '23:59:59',
        timezone,
      }).getTime() / 1000,
    );
  }

  return serialized;
}

export function deserializeActionDate({
  timezone,
  endsGT,
  startsLT,
}: {
  timezone: IanaTimezone;
  endsGT: number | null;
  startsLT: number | null;
}) {
  const deserialized: { endsGT?: DateString; startsLT?: DateString } = {};

  if (endsGT) {
    deserialized.endsGT = offsetDateInstance(new Date(endsGT * 1000), {
      fromTimezone: timezone,
      toTimezone: timezone,
    }).date;
  }

  if (startsLT) {
    deserialized.startsLT = offsetDateInstance(new Date(startsLT * 1000), {
      fromTimezone: timezone,
      toTimezone: timezone,
    }).date;
  }

  return deserialized;
}
